import store from '@/store'
import localStorageUtils from '@/utils/setLocalStorage'

/**
 * 获取缓存
 * @param {*} cacheName 缓存名称
 * @returns resultBool 参数
 */
export function getCacheParams(cacheName) {
  const buttonPermissions = store.getters && store.getters.toolConfig
  // 后端无如何缓存
  if (Array.isArray(buttonPermissions)) {
    return {}
  }
  // 优先使用后端缓存
  if (buttonPermissions[cacheName]) {
    return JSON.parse(buttonPermissions[cacheName]['config'])
  }
  return localStorageUtils.getItem(cacheName) || {}
}
